import { render, staticRenderFns } from "./LoadingGroup.vue?vue&type=template&id=06e7975a"
import script from "./LoadingGroup.vue?vue&type=script&lang=js"
export * from "./LoadingGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports